import constant from './constant'

export const toServerSideQuery = ({ filters, options }) => {
  let pageSize = options.itemsPerPage ?? constant.defaultPageSize
  if (pageSize == -1) {
    pageSize = constant.maxPageSize
  }
  return {
    ...filters,
    page: options.page ?? 1,
    page_size: pageSize,
    sort: toServerSideSort(options),
  }
}
export const toServerSideSort = ({ sortBy, sortDesc }) => {
  if (!sortBy || sortBy.length < 1) {
    return null
  }
  const result = []
  sortBy.forEach(function (val, index) {
    const sortDir = sortDesc[index] ? 'desc' : 'asc'
    result.push(`${val},${sortDir}`)
  })
  return result
}

export const toQueryString = (params) => {
  return qs.stringify(params, {
    arrayFormat: 'indices',
    allowDots: true,
    skipNulls: true,
  })
}

export const parseQueryString = (str) => {
  const params = qs.parse(str, { allowDots: true })
  console.log(params)
  return params
}

export const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)

export default {
  toServerSideQuery,
  toServerSideSort,
  toQueryString,
  parseQueryString,
  range,
}
